import cx from "classnames";
import type { ComponentProps, CSSProperties, ReactNode } from "react";
import type { StandardProperties } from "csstype";

import EditableItemGroup from "../../Utils/EditableItemGroup/EditableItemGroup";
import { type ButtonProps, Flex, OverflowText } from "@theorgchartdev/storybook";

type Props = {
  actions: ComponentProps<typeof EditableItemGroup>["actions"];
  className?: string;
  contentBefore?: ReactNode;
  label?: string;
  labelProps?: Partial<ComponentProps<typeof OverflowText>>;
  contentAfter?: ReactNode;
  dataTestId?: string;
  buttonSize?: ButtonProps["size"];
  innerFlexProps?: ComponentProps<typeof Flex>;
  flexProps?: ComponentProps<typeof Flex>;
  padding?: "large" | "medium" | "small" | StandardProperties["padding"];
  visible?: "always" | "hover";
  customStyle?: CSSProperties;
  spaceBetween?: boolean;
  buttonsInHierarchy?: boolean;
  focusable?: boolean;
};

const presetPadding: Primitive[] = ["large", "medium", "small"];

const ActionListItem = (props: Props) => {
  const isPresetPadding = presetPadding.includes(props.padding);

  return (
    <EditableItemGroup
      customClass={cx(props.className, {
        [`oc-action-list-item__${props.padding}`]: isPresetPadding
      })}
      spaceBetween={props.spaceBetween !== undefined ? props.spaceBetween : true}
      actions={props.actions}
      visible={props.visible}
      dataTestId={props.dataTestId}
      customStyle={props.customStyle}
      buttonSize={props.buttonSize}
      buttonsInHierarchy={props.buttonsInHierarchy}
      focusable={props.focusable}
    >
      <Flex
        flex={1}
        padding={!isPresetPadding ? (props.padding ?? "4px") : undefined}
        gap="4px"
        justifyContent={props.spaceBetween ? "space-between" : "flex-start"}
        overflow="hidden"
        {...props.flexProps}
      >
        <Flex flex={"1"} gap="4px" overflow="hidden" {...props.innerFlexProps}>
          {props.contentBefore}
          {props.label && (
            <OverflowText
              {...props?.labelProps}
              className={cx("oc-block", props.labelProps?.className)}
            >
              {props.label}
            </OverflowText>
          )}
        </Flex>
        {props.contentAfter}
      </Flex>
    </EditableItemGroup>
  );
};

export default ActionListItem;
